const translations: Record<string, string> = {
  "ak_docspage_contracts": "Contracts",
  "ak_docspage_reporting": "Reporting",
  "ak_docspage_technical_documentation": "Technical documentation",
  "ak_docspage_regulatory_acts": "Regulatory acts",
  "ak_docspage_all": "All",
  "ak_docspage_monthly": "Monthly",
  "ak_docspage_quarterly": "Quarterly",
  "ak_docspage_annual": "Annual",
  "ak_docspage_the_legislation_registry_pages_respond": "The legislation registry pages respond slowly - this is their server. You can open the document in a separate tab with the button at the top.",
  "ak_docspage_the_registry_currently_contains_only_a": "The registry currently contains only a list of documents. Viewing and downloading will work as soon as the files are linked to the facility.",
  "ak_docspage_of": "{{ok}} of {{total}}",
  "ak_docspage_download": "Download",
  "ak_docspage_open_source": "Open source",
  "ak_docspage_not_yet_concluded": "not yet concluded",
  "ak_docspage_not_applicable": "not applicable",
  "ak_docspage_station_documents": "Station documents",
  "ak_docspage_monthly_2": "monthly",
  "ak_docspage_quarterly_2": "quarterly",
  "ak_docspage_annual_2": "annual",
  "ak_docspage_no_file": "no file",
  "ak_docspage_select_a_document_from_the_list": "Select a document from the list",
  "ak_docspage_details_not_specified": "details not specified",
  "ak_docspage_preview_is_not_available_in_the_portal": "Preview is not available in the portal",
  "ak_docspage_the_browser_cannot_display_spreadsheet": "The browser cannot display spreadsheets inside the page. The file can be downloaded.",
  "ak_docspage_loading_from_zakon_rada_gov_ua": "Loading from zakon.rada.gov.ua…",
  "ak_docspage_opening_the_document": "Opening the document…",
  "ak_docspage_file_not_uploaded_yet": "File not uploaded yet",
  "ak_docspage_documents": "Documents",
  "ak_docspage_all_years": "All years",
  "ak_docspage_there_are_no_contract_dates_in_the_reg": "There are no contract dates in the registry yet - years will appear along with them.",
  "ak_docspage_search_documents": "Search documents…",
  "ak_docspage_a_z": "A → Z",
  "ak_docspage_z_a": "Z → A",
  "ak_docspage_nothing_found": "Nothing found.",
};

export default translations;
